import { Link } from "react-router-dom";
import placeholder from "../../../assets/images/placeholder.png";

export default function Course({ course }: any) {
  return (
    <Link
      to={`/courses/${course?._id}`}
      className="col-span-12 md:col-span-6 lg:col-span-2 cursor-pointer"
    >
      <div className="border mb-1 bg-white flex flex-col text-sm hover:bg-gray-50">
        <div className="bg-white border-b">
          <div
            className="relative w-full h-0"
            style={{ paddingBottom: "100%" }}
          >
            <img
              src={course?.thumbnail?.url || placeholder}
              alt=""
              className="absolute w-full h-full object-scale-down"
            />
          </div>
        </div>
        <div className="p-2">
          <div className="text-xl border-b pb-2 mb-2 truncate">
            {course?.name}
          </div>
          <div className="text-gray-500 h-20">
            <p className="line-clamp-3">{course?.description}</p>
          </div>
        </div>
      </div>
    </Link>
  );
}
